import React, { useState, ChangeEvent, FormEvent } from 'react';
import api from '../../../utils/api';
import styled from 'styled-components';
import Word from '../../../models/Word';
import { ActionButton,CancelButton } from '../common/AdminButtons';
import { Form, Input, FormGroup, ButtonGroup } from '../common/AdminForm';
import { ErrorMessage } from '../common/AdminMessages';
import { FormContainer } from '../common/FormContainer';



// Props interface for the WordForm component
interface WordFormProps {
    initialWord?: Word; // If provided, indicates edit mode; otherwise, add mode.
    jargonId: number; // Required for associating a word with a Jargon
    onSuccess: () => void;
    onCancel: () => void;
}

const WordForm: React.FC<WordFormProps> = ({ initialWord, jargonId, onSuccess, onCancel }) => {
    const [formData, setFormData] = useState<Word>(
        initialWord || {
            id: 0,
            jargonId: jargonId,
            word: '',
            partOfSpeech: '',
        }
    );
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        let response;
        try {
            setFormData(prevState => ({
                ...prevState, 
                jargonId: jargonId
            }));
            if (initialWord) {
                response = await api.put<Word>(`/halo/words/${initialWord.id}`, formData);
            } else {
                response = await api.post<Word>('/halo/words', formData);
            }

            if (response.status >= 200 && response.status < 300) {
                onSuccess();
            } else {
                setErrorMessage(`HTTP ${response.status}: ${response.statusText}`);
                console.log(`Received HTTP ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            setErrorMessage('Failed to save the word.');
            console.error("Error saving word:", error);
        }
    };
    return (
        
        <FormContainer>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <Form onSubmit={handleSubmit}>
                <label htmlFor="word">Word</label>
                <Input
                    type="text"
                    name="word"
                    value={formData.word}
                    onChange={handleInputChange}
                    required
                />
                <label htmlFor="partOfSpeech">Part of Speech</label>
                <Input
                    type="text"
                    name="partOfSpeech"
                    value={formData.partOfSpeech}
                    onChange={handleInputChange}
                    required
                />
                <ButtonGroup>
                    <ActionButton type="submit">
                        {initialWord ? 'Update Word' : 'Add Word'}
                    </ActionButton>
                    <CancelButton type="button" onClick={onCancel}>
                        Cancel
                    </CancelButton>
                </ButtonGroup>
            </Form>
        </FormContainer>
    );
};

export default WordForm;
